import axios from "axios";

// const API_BASE_URL = "https://attendance-api-woad.vercel.app/api";
// const API_BASE_URL = "http://localhost:6001/api";
// const API_BASE_URL ="http://192.168.50.44:6001/api";  
// const API_BASE_URL ="http://192.168.1.50:8082/api";  
const API_BASE_URL = "https://dbskillsattendance.iilos.org/api";    


 





const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});


 

export default axiosInstance;
